<section id="inicio">
    <app-details-banner [config]="config"></app-details-banner>
</section>